import { UserOutlined, QuestionOutlined, CommentOutlined, BuildOutlined, CreditCardOutlined, TeamOutlined, ClockCircleOutlined, IdcardOutlined, MailOutlined, UploadOutlined, HomeOutlined, FileTextOutlined, SolutionOutlined, ToolOutlined, ApartmentOutlined } from "@ant-design/icons";
import PrefixPath from "./AppConfig";

// const extraNavTree = [];
const commonNavTree = [];
const userNavTree = {
    admin: [
        {
            key: "C2",
            icon: <MailOutlined />,
            label: "CAM",
            path: `${PrefixPath.APP_PREFIX_PATH}/cam`,
        },
        {
            key: "B1",
            icon: <BuildOutlined />,
            label: "BLU",
            path: `${PrefixPath.APP_PREFIX_PATH}/blu`,
        },
        {
            key: "F1",
            icon: <QuestionOutlined />,
            label: "FAQ",
            path: `${PrefixPath.APP_PREFIX_PATH}/faq`,
        },
        {
            key: "R1",
            icon: <SolutionOutlined />,
            label: "RIC",
            path: `${PrefixPath.APP_PREFIX_PATH}/ric`,
        },
        {
            key: "C1",
            icon: <ClockCircleOutlined />,
            label: "CAT",
            path: `${PrefixPath.APP_PREFIX_PATH}/cat`,
        },
        {
            key: "M1",
            icon: <IdcardOutlined />,
            label: "MAT",
            path: `${PrefixPath.APP_PREFIX_PATH}/mat`,
        },
        {
            key: "S1",
            icon: <CommentOutlined />,
            label: "SMS",
            path: `${PrefixPath.APP_PREFIX_PATH}/sms`,
        },
        {
            key: "T1",
            icon: <UserOutlined />,
            label: "Tenant Registration",
            children: [
                {
                    key: "T12",
                    label: "Disclaimers",
                    icon: <UserOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/Disclaimers`,
                },
                {
                    key: "T13",
                    label: "Fees",
                    icon: <UserOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/RegistrationFees`,
                },
                {
                    key: "T11",
                    label: "Submissions",
                    icon: <UserOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/TenantRegistrations`,
                },
            ],
        },
        {
            key: "A1",
            icon: <HomeOutlined />,
            label: "All Access",
            children: [
                {
                    key: "U1",
                    label: "Users",
                    icon: <TeamOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/user`,
                    order: 1,
                },
                {
                    key: "M2",
                    label: "Schedule Maintenance",
                    icon: <ToolOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/maintenance-setup`,
                    order: 2
                },
                {
                    key: 'A11',
                    icon: <ToolOutlined/>,
                    label: 'Admin Tool',
                    path: `${PrefixPath.APP_PREFIX_PATH}/admin-tool`,
                },
                {
                    key: 'C12',
                    icon: <ApartmentOutlined/>,
                    label: 'Community Permissions',
                    path: `${PrefixPath.APP_PREFIX_PATH}/community/permissions`,
                },
            ]
        },
        {
            key: "V1",
            icon: <CreditCardOutlined />,
            label: "VMS Invoice",
            children: [
                {
                    key: "V12",
                    label: "Invoice Batches",
                    icon: <FileTextOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/vms-invoice/batches`,
                },
                {
                    key: "V11",
                    label: "Upload Invoice",
                    icon: <UploadOutlined />,
                    path: `${PrefixPath.APP_PREFIX_PATH}/vms-invoice/upload`,
                },
            ],
        },
    ],

};

const sortMenuTree = (menu = []) => {
    if (!Array.isArray(menu)) return [];

    return menu
        .map((item) => {
            const children = item?.children ? sortMenuTree(item.children) : item?.children;

            return {
                ...item,
                ...(children ? { children } : {})
            };
        })
        .sort((a, b) =>
            (a?.label ?? "").localeCompare(b?.label ?? "", undefined, {
                sensitivity: "base"
            })
        );
};

const sortedUserNavTree = {
    ...userNavTree,
    admin: sortMenuTree(userNavTree?.admin)
};

const navigationConfig = {
    common: commonNavTree,
    userRoles: sortedUserNavTree,
};

export default navigationConfig;
